import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface ReferToneResponse extends APIResponse
{

}

export class ReferToneResponseDtoImpl extends APIResponseDtoImpl implements ReferToneResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/tune/refertone/refertoneresponse.tsx